export default [{
  name: 'dbs',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaBanco: {}
      },
      DadosDesembolso: {
        AgenciaPagamento: '',
        ContaPagamento: '',
      }
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {}
        },
        DadosDesembolso: {
          AgenciaPagamento: '',
          ContaPagamento: '',
        }
      }
      commit('model', data)
    }
  }
}]
